module.exports = __webpack_public_path__ + "static/media/unibest-solution-img3.e770afec.png";